<template>
<!-- 三大服务-眼科 -->
    <div class="content">
        <div class="eye">
            <img class="pic" src="../assets/icon_touxiang 2@2x.png" alt="pic">
            <div class="title">近视防控、膳食营养</div>
            <div class="container">
                <!-- <p><span class="mafan">姓名</span><span>：李婕</span></p>
                <p><span class="mafan">性别</span><span>：女</span></p>
                <p><span class="mafan">民族</span><span>：汉族</span></p>
                <p><span class="mafan">国籍</span><span>：中国</span></p>
                <p><span>出生日期</span><span>：1973年3月13日</span></p>
                <p><span>工作单位</span><span>：北京方和科技有限责任公司</span></p>
                <p><span class="mafan">职位</span><span>：眼健康事业部主任</span></p>
                <p><span class="mafan">学历</span><span>：大学本科</span></p>
                <p><span class="mafan">电话</span><span>：13501031717</span></p> -->
                <p><span>中国营养学会会员卡号</span><span>:M100120481M</span></p>
                <!-- <p><span>通讯地址</span><span>：北京市海淀区彩和坊路10号，1+1大厦，605室（邮编100080）</span></p> -->
                
                <!-- <p class="top">教育情况：</p> -->
                <p class="top">1991年9月至1995年7月：北京联合大学应用文理学院，生物系，食品科学与营养学专业，大学本科。理学学士学位。</p>

                <!-- <p class="top">职业经历：</p> -->
                <p class="top">1995年7月至2001年7月：北京圣海伦科技有限责任公司，负责抗衰老功能食品的研发和进口保健品，食品的销售。</p>
            
                <p class="top">2001年7月至今：北京方和科技有限责任公司，眼健康事业部主任、近视防治服务中心主任。保健品研发和医疗器械的销售。负责不同年龄段青少年及成人膳食配餐健康管理，强化眼部营养膳食，眼健康功能食品。</p>

                <p class="top no_text_indent">主要成就及原创文章：</p>
                <p>《游泳》杂志特约撰稿人</p>
                <p>茄子营养师讲师团成员</p>
                <p>茄子营养师（微信公众号）特约撰稿人</p>
                <p>知名营养学科普作者</p>
                <p>中粮数字健康特邀讲师</p>
                <p>铁人三项爱好者</p>

                <p class="top no_text_indent">《探索成人学习游泳方法技术（一）至（九）》</p>
                <p>《成人学习游泳有错必纠系列》</p>
                <p>父母必读的《早安早餐，您家的早餐能得多分？》</p>
                <p>《胆固醇，一场错判了38年的冤案》</p>
                <p>《1口鱿鱼=40口肥肉？吃鱿鱼真的高胆固醇又长膘？》</p>
                <p>《上火溃疡惹人烦！多吃这些包你好！》</p>
                <p>《护眼四大营养素，缺一不可 | 最全的「护眼食谱」》</p>
                <p>《挑选全麦面包的最强详解 | 多图预警》</p>
            </div>
            
        </div>
        <div class="QRcodeBox">
            <!-- <div class="QRcode"></div> -->
            <img class="QRcode" src="../assets/erweima@2x.png">
        </div>

        <div class="card">
            <div>扫码进群</div>
            <div>仅限500人</div>
            <div>开放时间：周三上午9:00~11:00</div>

            <div>
                上次讨论纪要：1.....
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style scoped>
.content {
    padding: 28px;
}
.eye {
    padding: 28px;
    background: #fff;
    border-radius: 25px;
}
.eye .pic {
    width: 150px;
    height: 150px;
    /* background: #c34a45; */
    border-radius: 50%;
    display: block;
    margin: 0 auto 40px;
}
.eye .title {
    text-align: center;
    letter-spacing: 4px;
    margin-bottom: 60px;
}

.eye p {
    line-height: 52px;
}

.eye p span.mafan {
    display: inline-block;
    width: 140px;
    text-align: justify;
    text-align-last: justify;
}

.top {
    margin-top: 40px;
    text-indent: 40px;
}

.no_text_indent {
    text-indent: 0px;
}

.QRcodeBox {
    width: 252px;
    height: 252px;
    background: #fff;
    margin: 28px auto;
    padding: 28px;
    border-radius: 25px;
}

.QRcode {
    width: 100%;
    height: 100%;
    /* background: #c34a45; */
}

.card {
    padding: 28px;
    background: #fff;
    text-align: center;
    margin-bottom: 26px;
}

.card div{
    margin-bottom: 26px;
}

.card div:nth-of-type(2) {
    font-size: 34px;
    color: #c34a45;
}

.card div:last-of-type {
    text-align: left;
    font-size: 38px;
}

.container {
    font-size: 38px;
}
</style>


// WEBPACK FOOTER //
// src/views/Myopia.vue